import {
  PosVendaProtocoloListItemDto,
  PosVendaProtocolosFiltros,
} from '../../types/posVenda';

export function protocoloStatusFechado(status: string): boolean {
  const lower = status.toLowerCase();
  return lower === 'concluido' || lower === 'cancelado';
}

/** Kanban sem filtro de status: exibe apenas protocolos ainda abertos. */
export function filtrarProtocolosKanbanAbertos(
  items: PosVendaProtocoloListItemDto[],
  statusFiltro?: PosVendaProtocolosFiltros['status']
): PosVendaProtocoloListItemDto[] {
  if (statusFiltro) return items;
  return items.filter((p) => !protocoloStatusFechado(p.status));
}

export function compararProtocolosPorPrazo(
  a: PosVendaProtocoloListItemDto,
  b: PosVendaProtocoloListItemDto
): number {
  const pa = a.prazoConclusaoEm ? Date.parse(a.prazoConclusaoEm) : Number.MAX_SAFE_INTEGER;
  const pb = b.prazoConclusaoEm ? Date.parse(b.prazoConclusaoEm) : Number.MAX_SAFE_INTEGER;
  if (pa !== pb) return pa - pb;
  const slaDiff = (a.slaPercentualConsumido ?? 0) - (b.slaPercentualConsumido ?? 0);
  if (slaDiff !== 0) return slaDiff;
  return a.numero.localeCompare(b.numero, 'pt-BR');
}

/** Mantém ordem por prazo (mais urgente primeiro), alinhado à listagem da API. */
export function ordenarProtocolosKanban(
  items: PosVendaProtocoloListItemDto[]
): PosVendaProtocoloListItemDto[] {
  return [...items].sort(compararProtocolosPorPrazo);
}

export function prepararItensKanban(
  items: PosVendaProtocoloListItemDto[],
  statusFiltro?: PosVendaProtocolosFiltros['status']
): PosVendaProtocoloListItemDto[] {
  return ordenarProtocolosKanban(filtrarProtocolosKanbanAbertos(items, statusFiltro));
}
